import * as React from "react";
import ReactDOM from "react-dom";

interface PortalProps extends React.HTMLAttributes<HTMLDivElement> {
  /** The container to render the portal in. Defaults to `document.body` if not set */
  containerRef?: React.RefObject<HTMLElement>;
}

/**
 * Renders a React subtree in a different part of the DOM.
 */
export const Portal = React.forwardRef<HTMLDivElement, PortalProps>(
  ({ containerRef, ...rest }, forwardedRef) => {
    const container = containerRef?.current ?? globalThis.document?.body;

    const [, forceUpdate] = React.useState({});

    /**
     * containerRef.current won't be set on first render, so we force a re-render.
     * Because we do this in `useLayoutEffect`, we still avoid a flash.
     */
    React.useLayoutEffect(() => {
      forceUpdate({});
    }, []);

    if (container) {
      return ReactDOM.createPortal(
        <div data-capsule-portal {...rest} ref={forwardedRef} />,
        container
      );
    }
    return null;
  }
);
